module.exports = __webpack_public_path__ + "static/media/tfs-logo.0a24db57.jpg";